import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { PropertyTags } from './PropertyTags';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyValue = ({
  fieldType,
  numberDisplayHint,
  value
}) => {
  if (fieldType === 'checkbox' && Array.isArray(value)) {
    return /*#__PURE__*/_jsx(PropertyTags, {
      maxTags: 8,
      value: value
    });
  }
  const stringValue = value;
  if (fieldType === 'phonenumber') {
    return /*#__PURE__*/_jsx(FormattedPhoneNumber, {
      value: stringValue
    });
  }
  if (fieldType === 'number' && numberDisplayHint === 'currency') {
    return /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      currencyCode: "USD",
      precision: 0,
      value: parseInt(stringValue, 10)
    });
  }
  if (fieldType === 'number') {
    return /*#__PURE__*/_jsx(FormattedNumber, {
      value: parseInt(stringValue, 10)
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: stringValue
  });
};